import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { TALENTS, ASPIRATION_CELLS } from '../../data/staticContent';

const TIMELINE = [
  { tKey:'t1', dotClass:'timeline-dot' },
  { tKey:'t2', dotClass:'timeline-dot timeline-dot-accent' },
  { tKey:'t3', dotClass:'timeline-dot' },
  { tKey:'t4', dotClass:'timeline-dot timeline-dot-accent' },
  { tKey:'t5', dotClass:'timeline-dot' },
  { tKey:'t6', dotClass:'timeline-dot timeline-dot-accent' },
];

const PILLARS = [
  { pKey:'p1', icon:'bi-shield-fill',       cls:'card-icon-primary'   },
  { pKey:'p2', icon:'bi-sunglasses',         cls:'card-icon-secondary' },
  { pKey:'p3', icon:'bi-hand-index-thumb',   cls:'card-icon-accent'   },
  { pKey:'p4', icon:'bi-heart-fill',         cls:'card-icon-rose'     },
  { pKey:'p5', icon:'bi-lightbulb-fill',     cls:'card-icon-gold'     },
  { pKey:'p6', icon:'bi-flower1',            cls:'card-icon-purple'   },
];

const WhoIsChaitralee = () => {
  const { t } = useLanguage();

  return (
    <>
      {/* ── Intro ── */}
      <section className="section-pad">
        <div className="container">
          <div className="row align-items-center g-5">
           <div className="col-lg-5">
  <div style={{ position: 'relative' }}>
    <div className="img-portrait-frame" style={{ height: '480px', overflow: 'hidden' }}>
      <img
        src="/assets/images/370.jpg.jpeg"
        alt="Chaitralee"
        style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'center', display: 'block', borderRadius: 'inherit' }}
      />
    </div>
    <div className="float-card-primary" style={{ position: 'absolute', bottom: '-1.2rem', right: '-1.2rem', maxWidth: '195px', zIndex: 2 }}>
      <div className="float-quote-text">"Rose Colour Glasses"</div>
      <div className="float-quote-sub">Her philosophy of life</div>
    </div>
  </div>
</div>
            <div className="col-lg-7">
              <span className="eyebrow-badge" style={{background:'rgba(139,34,82,0.07)',border:'1px solid rgba(139,34,82,0.2)',color:'var(--brand-primary)'}}>
                <i className="bi bi-flower1"></i>5 March 2005 – 1 November 2024
              </span>
              <h2 className="section-title mt-2">{t('who.childhoodTitle')}</h2>
              <div className="divider-brand"></div>
              <p className="body-text">{t('who.intro')}</p>
              <p className="body-text">{t('who.childhoodText')}</p>
              <div className="row g-3 mt-1 mb-4">
                {[
                  { icon:'bi-chat-left-quote-fill', text:'वक्तृत्व / Oratory' },
                  { icon:'bi-music-note-beamed',    text:'कथक / Kathak' },
                  { icon:'bi-pencil-fill',           text:'लेखन / Writing' },
                  { icon:'bi-book-fill',             text:'वाचन / Reading' },
                ].map(({ icon, text }) => (
                  <div className="col-6" key={text}>
                    <div className="d-flex align-items-center gap-2 p-2 rounded-3 bg-card border border-site">
                      <i className={'bi ' + icon + ' text-brand'} style={{fontSize:'1rem'}}></i>
                      <span className="font-sans text-sub" style={{fontSize:'0.82rem',fontWeight:500}}>{text}</span>
                    </div>
                  </div>
                ))}
              </div>
              <Link to="/chaitralee-world" className="btn-accent">
                {t('who.legacyCta')} <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── Timeline + Talents ── */}
      <section className="section-pad-alt">
        <div className="container">
          <div className="row g-5">

            {/* Timeline */}
            <div className="col-lg-6">
              <span className="eyebrow"><i className="bi bi-clock-history me-2"></i>Timeline</span>
              <h2 className="section-title">{t('whoExtra.timelineTitle')}</h2>
              <div className="divider-brand"></div>
              <div className="timeline-wrap mt-4">
                {TIMELINE.map(({ tKey, dotClass }) => (
                  <div className="timeline-item" key={tKey}>
                    <div className={dotClass}></div>
                    <div className="timeline-year">{t('whoExtra.' + tKey + 'Year')}</div>
                    <div className="timeline-title">{t('whoExtra.' + tKey + 'Title')}</div>
                    <p className="timeline-desc">{t('whoExtra.' + tKey + 'Desc')}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Talents */}
            <div className="col-lg-6">
              <span className="eyebrow"><i className="bi bi-stars me-2"></i>Gifts</span>
              <h2 className="section-title">{t('who.talentsTitle')}</h2>
              <div className="divider-brand"></div>
              <div className="d-flex flex-column gap-3 mt-4">
                {TALENTS.map(({ key, icon, talentIconClass }) => (
                  <div className="talent-card" key={key}>
                    <div className={'talent-icon ' + talentIconClass}>
                      <i className={'bi ' + icon}></i>
                    </div>
                    <div>
                      <div className="talent-name">{t('who.' + key)}</div>
                      <p className="talent-desc mb-0">{t('who.' + key + 'Desc')}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── Pillars ── */}
      <section className="section-pad">
        <div className="container">
          <div className="text-center mb-5">
            <span className="eyebrow"><i className="bi bi-gem me-2"></i>Character</span>
            <h2 className="section-title">{t('whoExtra.pillarsTitle')}</h2>
            <div className="divider-brand-center"></div>
            <p className="section-subtitle">{t('whoExtra.pillarsSubtitle')}</p>
          </div>
          <div className="row g-4">
            {PILLARS.map(({ pKey, icon, cls }, i) => (
              <div className="col-lg-4 col-md-6" key={pKey}>
                <div className={'pillar-card anim-fade-up anim-delay-' + (i+1)}>
                  <div className={'pillar-icon ' + cls}>
                    <i className={'bi ' + icon}></i>
                  </div>
                  <div className="pillar-title">{t('whoExtra.' + pKey + 'Title')}</div>
                  <p className="pillar-desc mb-0">{t('whoExtra.' + pKey + 'Desc')}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Aspiration ── */}
      <section className="section-pad-alt">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <span className="eyebrow"><i className="bi bi-star-fill me-2"></i>Her Dream</span>
              <h2 className="section-title">{t('who.aspirationTitle')}</h2>
              <div className="divider-brand"></div>
              <p className="body-text">{t('who.aspirationText')}</p>
              <div className="inline-quote">
                <div className="inline-quote-text">{t('who.mentorQuote')}</div>
                <div className="inline-quote-attr">{t('who.mentorAttr')}</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="row g-3">
                {ASPIRATION_CELLS.map(({ key, icon, cellClass, iconColor }, i) => (
                  <div className="col-6" key={key}>
                    <div className={'anim-fade-up anim-delay-' + (i+1) + ' ' + cellClass}>
                      <i className={'bi ' + icon + ' ' + iconColor + ' aspiration-cell-icon'}></i>
                      <div className="aspiration-cell-label">{t('who.' + key)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Legacy ── */}
      <section className="quote-section">
        <div className="container position-relative" style={{zIndex:1}}>
          <div className="text-center">
            <h2 className="section-title-light mb-3">{t('who.legacyTitle')}</h2>
            <div className="divider-white"></div>
            <p className="hero-desc text-center mx-auto mb-4" style={{maxWidth:'680px'}}>{t('who.legacyText')}</p>
            <Link to="/chaitralee-world" className="btn-white">
              <i className="bi bi-play-circle-fill"></i> {t('who.legacyCta')}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default WhoIsChaitralee;
